/**
 * Compounding queue action eligibility (POM-5455).
 *
 * Single source of truth for which compounding order statuses each bulk action
 * applies to. Kept in one place so the queue table, toolbar, and any future
 * consumer share the exact same rules — and so the force-return set can be
 * adjusted in one edit when the eligibility list is finalised.
 */

// Orders recallable through the standard Recall action (unchanged — POM-5410).
export const RECALLABLE_STATUSES = new Set(['SUBMITTED', 'ACCEPTED', 'RECALL_FAILED']);

/**
 * Orders eligible for Force Return — stuck/failed states that cannot progress
 * through the normal recall path. Mirrors the backend
 * FORCE_RETURN_ELIGIBLE_STATUSES (smartphos-core centralFillForceReturnService).
 * SHIPPED and DELIVERED are excluded: once central fill has shipped/delivered
 * the order it cannot be force returned (POM-5371).
 */
export const FORCE_RETURN_ELIGIBLE_STATUSES = new Set([
  // Allowed for now so SUBMITTED and ACCEPTED orders can be force-returned while
  // recall is not yet released. NOTE: force return does NOT notify the pharmacy, so
  // an ACCEPTED (actively-compounding) order may still ship — the modal warns on this.
  'SUBMITTED',
  'ACCEPTED',
  'SUBMIT_FAILED',
  'EXCEPTION',
  'CLINIC_NOT_CONFIGURED',
  'CLINIC_AUTOCREATE_FAILED',
  'PROVIDER_RESOLUTION_FAILED',
  'PATIENT_RESOLUTION_FAILED',
  'PRODUCT_NOT_MAPPED',
  'MISSING_REASON_FOR_COMPOUNDING',
  'RECALL_REQUESTED',
]);

/**
 * Orders eligible to be manually marked delivered (POM-5867). Mirrors the backend
 * STATUS_UPDATE_ELIGIBLE_FROM (smartphos-core centralFillStatusUpdateService).
 * SHIPPED is the ordinary missed-webhook case; ACCEPTED covers a pharmacy that
 * delivered without ever firing a shipping/shipped event.
 */
export const MARK_DELIVERED_ELIGIBLE_STATUSES = new Set(['SHIPPED', 'ACCEPTED']);
